module.exports = __webpack_public_path__ + "static/img/title.e12191f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-3/title.png
// module id = JGir
// module chunks = 0